export default __webpack_public_path__ + "static/01_Rat-42a48c2a9a5ed4dac641f6698f1a7e52.png";